import { createMFELogger } from '@wf-mfe/logger'

export default createMFELogger({ name: '@wf-mfe/api' })
